<nb-card>
    <nb-card-header>{{data.name}}</nb-card-header>
    <nb-card-body>
        <app-average-tou [touData]="touData"></app-average-tou>
    </nb-card-body>
    <nb-card-footer><button nbButton (click)="close()">{{"CLOSE" | translate}}</button></nb-card-footer>
</nb-card>